import axios from "config/axios/base";
import qs from "qs";

export const getNoteQuestions = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/notes/get_questions/${params?.id}?${qs.stringify(query)}`, options);
export const getNotes = ({ query = {}, options = null }) => axios.get(`/notes?${qs.stringify(query)}`, options);
export const postNotes = ({ body = {}, options = null }) => axios.post("/notes/store", body, options);
/** Merges `x-prevent-flashes: true` so Laravel `{ message: "Draft Saved" }` on routine PATCH does not spam global success toasts. Pass `headers: { "x-prevent-flashes": "false" }` to opt in. */
export const patchNotes = ({ params = {}, body = {}, options = null }) => {
	const opts = { ...(options || {}) };
	const headers = { ...(opts.headers || {}) };
	if (headers["x-prevent-flashes"] === undefined) {
		headers["x-prevent-flashes"] = "true";
	}
	opts.headers = headers;
	return axios.post(`/notes/update/${params?.id}?${qs.stringify({ _method: "PATCH" })}`, body, opts);
};
export const getNoteId = ({ query = {}, options = null }) =>
	axios.get(`/notes/get_note_id?${qs.stringify(query)}`, options);
export const getNote = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/notes/show/${params?.id}?${qs.stringify(query)}`, options);
export const deleteNote = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/notes/destroy/${params?.id}?${qs.stringify({ _method: "DELETE" })}`, body, options);
export const patchSetAnswer = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/set_answer/${params?.questionId}`, body, options);
export const patchSetAnswers = ({ body = {}, options = null }) => axios.patch("/notes/set_answers", body, options);
export const patchPatientSignature = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/patient_signature/${params?.noteId}`, body, options);
export const getAssessments = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/notes/get_assessments/${params?.id}?${qs.stringify(query)}`, options);
export const getDrugs = ({ query = {}, options = null }) =>
	axios.get(`/notes/get_drugs?${qs.stringify(query)}`, options);
export const patchAssessments = ({ body = {}, options = null }) =>
	axios.patch("/notes/updateNoteAssessment", body, options);
export const getStatements = ({ params = {}, options = null }) =>
	axios.get(`/notes/get_statements/${params?.id}`, options);
export const getProcedures = ({ params = {}, options = null }) =>
	axios.get(`/notes/getProcedures/${params?.id}`, options);
export const getOrders = ({ params = {}, options = null }) => axios.get(`/notes/get_orders/${params?.id}`, options);
export const patchSetOrder = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/set_order/${params?.id}`, body, options);
export const postSetAllAsNormal = ({ body = {}, options = null }) =>
	axios.post("/notes/set_all_as_normal", body, options);
export const patchProcedures = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/set_procedure/${params?.id}`, body, options);
export const patchNotesShare = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/share/${params?.id}`, body, options);
export const patchNotesValidateOtp = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/validate_otp/${params?.id}`, body, options);
export const patchAnswerDrugQuestions = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/answer_drug_questions/${params?.questionId}`, body, options);
export const patchSendShareNote = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/notes/send_share_note/${params?.id}`, body, options);
export const getNoteByShortId = ({ body = {}, options = null }) => axios.post(`/notes/find_by_short_id`, body, options);
export const patchRepeatQuestion = ({ params = {}, query = {}, body = {}, options = null }) =>
	axios.post(`/notes/repeat_question/${params?.id}?${qs.stringify(query)}`, body, options);
export const patchDeleteRepeatedQuestion = ({ params = {}, query = {}, body = {}, options = null }) =>
	axios.post(`/notes/delete_repeated_question/${params?.note_question_id}?${qs.stringify(query)}`, body, options);
export const getPatientId = ({ options = null }) => axios.get("/notes/get_patient_id", options);
export const getCanAccessQuestionnaire = ({ params = {}, options = null }) =>
	axios.get(`/notes/can-access/${params?.id}/questionnaire`, options);
